import FileHelper from "@/helpers/utilities/FileHelper";

export default class DriveItem {
  id;
  name;
  createdDateTime;
  lastModifiedDateTime;
  webUrl;
  size;
  createdBy;
  lastModifiedBy;
  parentReference;
  remoteItem;
  package;
  folder;
  root;
  childrenList;
  extension;
  listItem;
  nctMarkup;
  nctSystem = "other";
  nctType;
  nctGroup;
  nctIdentifier = "other";
  nctSharedToAula;
  nctBehavior;
  nctJournalizing;
  nctLocking;
  nctSpecialItemType;
  itemId;
  thumbnailUrl;

  constructor(apiDriveItem) {
    if (apiDriveItem) {
      this.id = apiDriveItem.id ? String(apiDriveItem.id) : undefined;
      this.name = apiDriveItem.name;
      this.createdDateTime = apiDriveItem.createdDateTime ? new Date(apiDriveItem.createdDateTime) : null;
      this.lastModifiedDateTime = apiDriveItem.lastModifiedDateTime
        ? new Date(apiDriveItem.lastModifiedDateTime)
        : null;
      this.webUrl = apiDriveItem.webUrl;
      this.size = apiDriveItem.size ? Number(apiDriveItem.size) : null;
      this.createdBy = apiDriveItem.createdBy;
      this.lastModifiedBy = apiDriveItem.lastModifiedBy;
      this.parentReference = {
        driveId: apiDriveItem.parentReference?.driveId,
        id: apiDriveItem.parentReference?.id ? String(apiDriveItem.parentReference.id) : undefined
      };
      this.remoteItem = apiDriveItem.remoteItem ? new DriveItem(apiDriveItem.remoteItem) : null;
      this.package = apiDriveItem.package;
      this.folder = apiDriveItem.folder;
      this.root = apiDriveItem.root;
      this.listItem = apiDriveItem.listItem;
      this.nctSystem = apiDriveItem.nctSystem || "other";
      this.nctType = apiDriveItem.nctType;
      this.nctGroup = apiDriveItem.nctGroup;
      this.nctIdentifier = apiDriveItem.nctIdentifier || "other";
      this.nctSharedToAula = apiDriveItem.nctSharedToAula;
      this.nctBehavior = apiDriveItem.nctBehavior;
      this.nctJournalizing = apiDriveItem.nctJournalizing;
      this.nctLocking = apiDriveItem.nctLocking;
      this.nctSpecialItemType = apiDriveItem.nctSpecialItemType;
      this.itemId = apiDriveItem.itemId;
      if (apiDriveItem.children) {
        this.childrenList = [];
        apiDriveItem.children.forEach(c => {
          this.childrenList.push(new DriveItem(c));
        });
      }
      this.children = apiDriveItem.children;
      if (Object.hasOwn(apiDriveItem, "extension")) {
        this.extension = apiDriveItem.extension;
        this.isFolder = apiDriveItem.isFolder;
      } else {
        if (Object.hasOwn(apiDriveItem, "folder")) {
          this.extension = FileHelper.getClosedFolderTemplate();
          this.isFolder = true;
        } else {
          this.extension = FileHelper.getFileExtensionObject(this.name);
        }
      }

      if (apiDriveItem.thumbnailUrl) {
        this.thumbnailUrl = apiDriveItem.thumbnailUrl;
      } else if (apiDriveItem.thumbnails && apiDriveItem.thumbnails[0] && apiDriveItem.thumbnails[0].small) {
        this.thumbnailUrl = apiDriveItem.thumbnails[0].small.url;
      }
    }
  }

  // Setters
  set children(childrens) {
    if (childrens) {
      this.childrenList = [];
      childrens.forEach(c => {
        this.childrenList.push(new DriveItem(c));
      });
    }
  }

  set nctSpecialItem(settings) {
    if (settings) {
      const clone = Object.assign({}, this.extension);
      clone.suffixIcon = settings.suffixIcon;
      clone.typeIcon = settings.typeIcon;
      if (clone.name === "Folder") {
        clone.color = settings.color;
      }
      this.extension = clone;
    }
  }

  // Getters
  get clone() {
    return new DriveItem(this);
  }

  get children() {
    return this.childrenList;
  }

  get sensitivityLabels() {
    const labels = [];

    if (this.listItem && this.listItem.fields && this.listItem.fields._DisplayName) {
      labels.push(...this.listItem.fields._DisplayName.split(","));
    }

    if (this.nctBehavior?.label) {
      labels.push(`Documents.Labels.${this.nctBehavior?.label}`);
    }

    if (
      this.nctType === "SubFolder" &&
      (this.nctIdentifier === "Journaliserede" || this.nctIdentifier === "LederJournaliserede")
    ) {
      labels.push("Documents.Labels.Journalized");
    }

    if (
      this.nctType === "SubFolder" &&
      (this.nctIdentifier === "Afsluttede" || this.nctIdentifier === "LederAfsluttede")
    ) {
      labels.push("Documents.Labels.Locked");
    }

    if (this.nctSharedToAula) {
      labels.push("Documents.Labels.SharedInAula");
    }

    if (this.nctJournalizing) {
      labels.push("Documents.Labels.JournalizingIsStarted");
    }

    if (this.nctLocking) {
      labels.push("Documents.Labels.LockingIsStarted");
    }

    return labels;
  }

  get isUnderStated() {
    if (this.nctType === "SubFolder" && this.nctBehavior?.state?.toLowerCase() === "understated") {
      return true;
    }
    return false;
  }

  /**
   * Expose behavior enum
   * @returns {object} Behavior enum
   */
  static get nctBehaviorType() {
    return nctBehaviorEnumDefinition;
  }
}

const nctBehaviorEnumDefinition = {
  NONE: 0,
  ACTIVE: 1
};
